"use strict";
/** state: Final **/
/** family: NavBar **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var trackMetric_1 = require("../../metrics/trackMetric");
var NavItemArrow_1 = require("../NavItemArrow");
var NavItemContent_1 = require("../NavItemContent");
var SafeAnchor_1 = require("../SafeAnchor");
var CLASS_NAME = 'i-nav-item';
var NavItemRole;
(function (NavItemRole) {
    NavItemRole["Presentation"] = "presentation";
})(NavItemRole = exports.NavItemRole || (exports.NavItemRole = {}));
function navItemOnClick(e, options, fn, disabled) {
    if (disabled) {
        e.preventDefault();
        return;
    }
    trackMetric_1.trackMetric(options, fn)(e);
}
/**
 * An item for a Nav group.
 *
 * @param props {@link NavItemProps}
 */
var NavItem = (function (_a) {
    var active = _a.active, _b = _a.arrow, arrow = _b === void 0 ? {} : _b, badge = _a.badge, children = _a.children, className = _a.className, disabled = _a.disabled, icon = _a.icon, iconName = _a.iconName, id = _a.id, isMobile = _a.isMobile, isTab = _a.isTab, showLoading = _a.showLoading, iconLoader = _a.iconLoader, label = _a.label, labelHidden = _a.labelHidden, layout = _a.layout, href = _a.href, onClick = _a.onClick, metricOptions = _a.metricOptions, mobileIcon = _a.mobileIcon, mobileIconName = _a.mobileIconName, restProps = __rest(_a, ["active", "arrow", "badge", "children", "className", "disabled", "icon", "iconName", "id", "isMobile", "isTab", "showLoading", "iconLoader", "label", "labelHidden", "layout", "href", "onClick", "metricOptions", "mobileIcon", "mobileIconName"]);
    var _c;
    return (React.createElement("li", __assign({ className: classNames(CLASS_NAME, 'nav-item', (_c = {
                active: !isTab && active,
                disabled: disabled
            },
            _c["i-nav-arrow i-nav-arrow--" + arrow.style + "-" + arrow.position] = !!(arrow.style && arrow.position),
            _c), className), role: isTab ? NavItemRole.Presentation : undefined }, restProps),
        React.createElement(SafeAnchor_1.SafeAnchor, { "aria-label": label, "aria-controls": isTab ? href.substr(1) : undefined, "aria-selected": isTab && active ? true : undefined, className: classNames(CLASS_NAME + "__button", 'nav-link', {
                active: isTab && active,
            }), role: isTab ? SafeAnchor_1.SafeAnchorRole.Tab : undefined, id: id, onClick: function (e) { return navItemOnClick(e, metricOptions, onClick, disabled); }, href: href },
            React.createElement(NavItemContent_1.NavItemContent, { badge: badge, icon: icon, iconName: iconName, iconLoader: iconLoader, isMobile: isMobile, label: label, labelHidden: labelHidden, layout: layout, mobileIcon: mobileIcon, mobileIconName: mobileIconName, showLoading: showLoading }),
            children)));
});
exports.NavItem = NavItem;
NavItem.Layout = NavItemContent_1.NavLayout;
NavItem.ArrowPosition = NavItemArrow_1.NavItemArrowPosition;
NavItem.ArrowStyle = NavItemArrow_1.NavItemArrowStyle;
NavItem.defaultProps = {
    active: false,
    tabIndex: -1,
};
//# sourceMappingURL=NavItem.js.map